import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-warn",
  "use": "icon-warn-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-warn\"><path d=\"M533.333333 170.666667L938.666667 853.333333H128l405.333333-682.666666zM204.8 810.666667h661.333333L533.333333 256 204.8 810.666667z m307.2-384h42.666667v213.333333h-42.666667v-213.333333z m0 256h42.666667v42.666666h-42.666667v-42.666666z\" p-id=\"2928\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol